import React from "react";
import SingleEventPage from "../../components/single-event-page/SingleEventPage";
import codeunscramble from "../../assets/event-images/codeunscramble.jpg";

const codeAuction = {
  image: codeunscramble,
  description:
    "Join us for an exciting programming competition where participants are presented with shuffled pseudocode for a series of problems and must rearrange it into the correct logical order.",
  type: "Technical Event",
  eventName: "Code Unscramble",
  dateTime: "Feb 28, 12:00PM - 1:30PM",
  venue: "IT-443",
  rules: [
    "Solo Participation",
    "The event has two levels: Level 1 and Level 2.",
    "Participants must rearrange shuffled pseudocode correctly and implement the solution in their preferred programming language.",
    "Level 1: Three types of problems - Moderate 1, Moderate 2, Hard.",
    "Participants earn points based on accuracy.",
    "Top scorers move to Level 2.",
    "Level 2: More complex Moderate and Hard problems - Moderate, Hard.",
    "Final rankings and winners are based on points earned."
 ],
  firstprize: 1000,
  secondprize: 500,
  thirdprize: 0,
  contact: [

    {
      name: "Sharmila C",
      phoneNo: "8220442454",
    },
    {
      name:"Dhanya Rithika S",
      phoneNo: "9442614014",
    }
  ],
};

const CodeAuction = () => {
  return <SingleEventPage eventDetails={codeAuction} />;
};

export default CodeAuction;
